// extracted by mini-css-extract-plugin
export default {"promoCodeCampaignText":"G4ef9f9","inputFieldContainer":"Gaafef4"};